import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _extends from "@babel/runtime/helpers/esm/extends";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from "prop-types";
import React, { Component } from "react";
import classNames from "classnames";
import { getRehydratableName, getClassNameFactory } from "../../utilities";
import CrossIcon from "@dcl/icons/esm/ui/cross";
import TickerItem from "./components/TickerItem";

var Ticker = /*#__PURE__*/function (_Component) {
  _inherits(Ticker, _Component);

  var _super = _createSuper(Ticker);

  function Ticker(props) {
    var _this;

    _classCallCheck(this, Ticker);

    _this = _super.call(this, props);
    _this.state = {
      currentTime: _this.props.initialTime,
      isAnimating: false,
      isClosed: false,
      isPaused: false
    };
    _this.pixelsPerSecond = 60;
    _this.getClassName = getClassNameFactory(Ticker.displayName);
    _this.handleCloseClick = _this.handleCloseClick.bind(_assertThisInitialized(_this));
    _this.handleContentEnter = _this.handleContentEnter.bind(_assertThisInitialized(_this));
    _this.handleContentLeave = _this.handleContentLeave.bind(_assertThisInitialized(_this));
    _this.handleItemsBlur = _this.handleItemsBlur.bind(_assertThisInitialized(_this));
    _this.handleItemsFocus = _this.handleItemsFocus.bind(_assertThisInitialized(_this));
    _this.updateTime = _this.updateTime.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Ticker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // We're in the browser - let's animate.
      this.setState({
        isAnimating: true,
        animationDuration: this.itemsInnerRef.offsetWidth / this.pixelsPerSecond
      });
    }
  }, {
    key: "handleCloseClick",
    value: function handleCloseClick() {
      this.setState({
        isClosed: true
      });
    }
  }, {
    key: "handleContentEnter",
    value: function handleContentEnter() {
      this.setState({
        isPaused: true
      });
    }
  }, {
    key: "handleContentLeave",
    value: function handleContentLeave() {
      this.setState({
        isPaused: false
      });
    }
  }, {
    key: "handleItemsFocus",
    value: function handleItemsFocus() {
      this.setState({
        isPaused: true
      });
    }
  }, {
    key: "handleItemsBlur",
    value: function handleItemsBlur() {
      this.itemsRef.scrollLeft = 0;
      this.setState({
        isPaused: false
      });
    }
  }, {
    key: "updateTime",
    value: function updateTime() {
      this.setState({
        currentTime: new Date().toISOString()
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var currentTime = this.state.currentTime;
      var itemsStyle = {
        animationDuration: "".concat(this.state.animationDuration || 0, "s")
      };
      var items = Ticker.getItems(this.props.children);
      return /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          states: classNames({
            animating: this.state.isAnimating,
            closed: this.state.isClosed,
            paused: this.state.isPaused
          })
        }),
        "data-initial-time": this.props.initialTime,
        "data-rehydratable": getRehydratableName(Ticker.displayName)
      }, /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "logo"
        })
      }, /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "logoInner"
        })
      })), /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "content"
        }),
        onMouseEnter: this.handleContentEnter,
        onMouseLeave: this.handleContentLeave
      }, /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "items"
        }),
        ref: function ref(_ref2) {
          _this2.itemsRef = _ref2;
        }
      }, /*#__PURE__*/React.createElement("ul", {
        className: this.getClassName({
          descendantName: "itemsInner"
        }),
        onAnimationIteration: this.updateTime,
        onFocus: this.handleItemsFocus,
        onBlur: this.handleItemsBlur,
        ref: function ref(_ref) {
          _this2.itemsInnerRef = _ref;
        },
        style: itemsStyle
      }, items.map(function (item) {
        return /*#__PURE__*/React.createElement(TickerItem, _extends({
          key: item.dateTime + item.title
        }, item, {
          currentTime: currentTime
        }));
      }))), /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "fade"
        })
      })), /*#__PURE__*/React.createElement("button", {
        className: this.getClassName({
          descendantName: "close"
        }),
        onClick: this.handleCloseClick,
        "aria-label": "Close news ticker"
      }, /*#__PURE__*/React.createElement("span", {
        className: this.getClassName({
          descendantName: "closeIcon"
        })
      }, /*#__PURE__*/React.createElement(CrossIcon, {
        label: "Close"
      }))));
    }
  }], [{
    key: "getItems",
    value: function getItems(children) {
      var items = [];
      React.Children.forEach(children, function (child) {
        if (child.type === TickerItem) {
          items.push(child.props);
        } else if (child.type === React.Fragment) {
          items.push.apply(items, _toConsumableArray(Ticker.getItems(child.props.children)));
        }
      });
      return items;
    }
  }]);

  return Ticker;
}(Component);

_defineProperty(Ticker, "displayName", "Ticker");

_defineProperty(Ticker, "propTypes", {
  /**
   * Items to display in this ticker. Each should be a `Ticker.Item`.
   */
  children: PropTypes.node,

  /**
   * An ISO 8601, RFC 2822, or `new Date(str)` compatible date string, which is used to compare relative time.
   */
  initialTime: PropTypes.string
});

Ticker.Item = TickerItem;
export default Ticker;